import {PIXI} from '@colonist/pixi'
import {SelectCardPopupStealCardFromAnotherPlayerFormat} from '@colonist/game-card-types'
import {UIGameManager} from '../UIGameManager'
import {UIGamePopupSelectCards} from './UIGamePopupSelectCards'
import {CardEnum} from '@colonist/game-states'

export class UIGamePopupSelectResourcesCardsFromPlayer extends UIGamePopupSelectCards {
    constructor(uiGameManager: UIGameManager, popupImageAndDescription: PIXI.Container, selectCardFormat: SelectCardPopupStealCardFromAnotherPlayerFormat) {
        super(uiGameManager, popupImageAndDescription, selectCardFormat.selectCardFormat)

        this.addVictimAvatarView(selectCardFormat.victim)

        this.selectCardContainer.cardsToSelectFrom.cardInventory.showCardBadges()
    }

    protected clickedTopResource(cardEnum: CardEnum) {
        if(this.selectedEnoughCards()) return
        super.clickedTopResource(cardEnum)
        this.selectCardContainer.cardsToSelectFrom.removeCard(cardEnum)
    }

    protected clickedSelectedResource(cardEnum: CardEnum) {
        super.clickedSelectedResource(cardEnum)
        this.selectCardContainer.cardsToSelectFrom.addNewCardOfType(cardEnum)
    }
}
